var jade = require("/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"modal-body\"><div class=\"row\"><section dias-cloak=\"ctx.loading\" cloak-msg=\"'Protokoll wird geladen...'\" class=\"main col-10 offset-1\"><div ng-if=\"ctx.sla.sla_protokoll\" ng-bind-html=\"ctx.sla.sla_protokoll\"></div><p ng-if=\"!ctx.sla.sla_protokoll\">[Noch kein Protokoll hinterlegt]</p></section></div></div><div class=\"modal-footer\"><div class=\"form-footer\"><div class=\"required\"></div><div class=\"form-actions\"><button ng-click=\"exit()\" class=\"btn btn-default\"><span>Schließen</span></button></div></div></div>");;return buf.join("");
}